(function(){
  if (window.__peptovaCatalogGateV54) return;
  window.__peptovaCatalogGateV54 = true;

  var modal = document.getElementById('pvcStackInvite');
  var launcher = document.getElementById('pvcStackLaunch');
  if (!modal || !launcher) return;

  var seenKey = 'pvc_catalog_gate_seen_v1';
  var fourteenDays = 14 * 24 * 60 * 60 * 1000;
  var pendingCatalogUrl = '/pages/catalog';
  var lastFocus = null;

  function getSeen(){
    try { return parseInt(localStorage.getItem(seenKey) || '0', 10); }
    catch (_) { return 0; }
  }
  function markSeen(){
    try { localStorage.setItem(seenKey, String(Date.now())); }
    catch (_) {}
  }
  function catalogUrlFrom(anchor){
    if (!anchor) return null;
    if (anchor.hasAttribute('data-pvc-catalog-bypass')) return null;
    var raw = anchor.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#' || raw.indexOf('javascript:') === 0) return null;
    var url;
    try { url = new URL(raw, window.location.href); }
    catch (_) { return null; }
    if (url.origin !== window.location.origin) return null;
    var path = url.pathname.replace(/\/$/, '') || '/';
    if (path === '/pages/catalog' || path === '/collections/all' || (path === '/' && url.hash === '#ptx-products')) {
      return '/pages/catalog';
    }
    return null;
  }
  function openGate(catalogUrl){
    pendingCatalogUrl = catalogUrl || '/pages/catalog';
    lastFocus = document.activeElement;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function(){ modal.classList.add('open'); });
    var first = modal.querySelector('[data-pvc-goal]');
    if (first) setTimeout(function(){ first.focus(); }, 180);
  }
  function closeGate(){
    markSeen();
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ modal.style.display = 'none'; }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }
  function browseAll(){
    markSeen();
    window.location.href = pendingCatalogUrl || '/pages/catalog';
  }
  function chooseGoal(goal){
    markSeen();
    window.location.href = '/pages/stack-builder?goal=' + encodeURIComponent(goal);
  }

  document.querySelectorAll('a[href="/collections/all"],a[href="/collections/all/"],a[href="/#ptx-products"]').forEach(function(anchor){
    anchor.setAttribute('href', '/pages/catalog');
  });

  document.addEventListener('click', function(event){
    var anchor = event.target.closest && event.target.closest('a');
    var destination = catalogUrlFrom(anchor);
    if (!destination) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openGate(destination);
  });

  launcher.addEventListener('click', function(){ openGate('/pages/catalog'); });
  modal.querySelectorAll('[data-pvc-close]').forEach(function(button){ button.addEventListener('click', closeGate); });
  modal.querySelector('[data-pvc-browse-all]').addEventListener('click', browseAll);
  modal.querySelectorAll('[data-pvc-goal]').forEach(function(button){
    button.addEventListener('click', function(){ chooseGoal(button.getAttribute('data-pvc-goal')); });
  });
  modal.addEventListener('click', function(event){ if (event.target === modal) closeGate(); });
  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape' && modal.classList.contains('open')) closeGate();
  });

  var onCatalog = window.location.pathname.replace(/\/$/, '') === '/pages/catalog';
  var bypass = new URLSearchParams(window.location.search).get('browse') === 'all';
  if (onCatalog && !bypass && Date.now() - getSeen() >= fourteenDays) {
    setTimeout(function(){ openGate('/pages/catalog?browse=all'); }, 500);
  }
})();
